export default __webpack_public_path__ + "static/media/AppGalleryBadge.bd347106.png";